<!-- Barra para adicionar conteudo entre sessoes -->
<template>
  <div :class="defaultClass">
    <div class="w-100 d-flex justify-content-center d-none" v-if="!active">
      <span v-b-tooltip.hover title="Criar">
        <button @click="firstClick" class="plus-button fal fa-plus"></button>
      </span>
    </div>
    <div v-else>
      <div class="wrapper d-flex justify-content-center flex-wrap">
        <div
          class="item-container"
          v-for="(button, index) in frameButtons"
          :key="button.index"
          @click="button.clickEvent(index)"
        >
          <div>
            <button
              class="btn
                d-flex
                flex-column
                justify-content-center
                align-items-center"
            >
              <i v-if="button.icon" :class="[button.icon]" class="fa-lg"></i>
              <img
                v-else
                class="img-svg img-svg-color"
                src="../../assets/img/icons/before-after.svg"
              />
              <span class="btn-text mt-3">{{ button.title }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      active: false,
      extraButtonStatus: true,
      defaultClass: 'new-post-container container col-sm-12 d-flex justify-content-center my-5 py-5',
    };
  },
  methods: {
    firstClick() {
      this.$emit("return-slot", this.slotNum);
      this.active = true;
    },

    toggleExtraButtons() {
      this.extraButtonStatus = true
    }
  },
  props: {
    frameButtons: Array,
    slotNum: Number
  },
};
</script>

<style scoped>
@keyframes fade {
  0% {
    opacity: 100%;
  }
  100% {
    opacity: 0;
  }
}
.new-post-container {
  margin-top: 10px;
  border-radius: 10px;
  transform: fade;
  animation-direction: reverse;
  transition: 0.5s;
}

@media (max-width:998px) {
  .new-post-container {
    width: 90%;
  }
}
.new-post-container:hover {
  box-shadow: 0 6px 40px 1px #dedede;
  transform: fade;
  transition: 0.5s;
}
.img-svg {
  width: 22px;
}
.plus-button {
  font-size: 1.8rem;
  width: 3rem;
  height: 3rem;
  color: #444;
  border: none;
  border-radius: 50%;
  background-color: #f3f3f3;
}
.bottom-button:hover {
  background-color: #e6e6e6;
}
.wrapper {
  justify-content: start;
  align-items: baseline;
}
.item-container {
  width: 6rem;
  text-align: -webkit-center;
}
.post-btn:hover {
  background-color: #cccccc;
}
.post-btn:hover .btn-text {
  color: var(--main-color);
}
.btn-text {
  font-size: 0.725rem;
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/AddPostBar.vue